export default __webpack_public_path__ + "static/media/guyWhite.01ed11d4.png";